// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"efff5b15","484":"8f847875","559":"f65d1398"}[chunkId] + ".chunk.css";
};